import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

import Pagination from "../../../../components/cm/Dashboard/FullPages/CaseList/CaseListList/components/Pagination";
import OrderingArrow from "../../../global/OrderingArrow";

import { CustomCell, DateCell, NumberCell, TextCell } from "./TableView/cells";

const getValueByPath = (obj, path) => {
  return path.split(".").reduce((acc, key) => acc?.[key], obj);
};

const TableView = ({
  columns,
  data,
  filters,
  updateFilter,
  displayIndexColumn = false,
  referenceForScrolling,
  count,
}) => {
  const [orderingVal, setOrderingVal] = useState(null);
  useEffect(() => {
    updateFilter("ordering", orderingVal);
  }, [orderingVal]);

  const renderCell = (col, value, rowIndex, colIndex) => {
    if (displayIndexColumn && colIndex === 0) {
      const offset = parseInt(filters.get("offset") || 0);
      value = offset + rowIndex + 1 + ". " + value;
    }
    // Check column type and render appropriate component
    switch (col.type) {
      case "date":
        return <DateCell value={value} />;
      case "number":
        return <NumberCell value={value} />;
      case "string":
        return <TextCell value={value} />;
      case "custom":
        return col.customComponent ? (
          <CustomCell value={value} Component={col.customComponent} />
        ) : (
          value
        );
      default:
        return value; // Default fallback if type is not specified
    }
  };

  return data.length === 0 ? (
    <div className="w-full items-center">
      <Typography className="text-center text-lg font-bold text-black">No data found</Typography>
    </div>
  ) : (
    <div className="flex h-full w-full flex-col">
      <table className="w-full table-fixed border-collapse overflow-hidden">
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key} className="border-b border-t-0 py-6 text-center">
                {col.label}
                {col.order && (
                  <OrderingArrow
                    val={col.orderingValue}
                    orderingVal={orderingVal}
                    setOrderingVal={setOrderingVal}
                  />
                )}
              </th>
            ))}
          </tr>
        </thead>
      </table>
      <div className="h-full overflow-y-auto p-2" ref={referenceForScrolling}>
        <table className="w-full table-fixed border-separate border-spacing-y-4">
          <tbody>
            {data.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                className="bg-table-hover group relative w-full rounded-md bg-red-100 p-2 text-black hover:cursor-pointer"
                style={{
                  backgroundColor: "#eaf5fd",
                }}
                onClick={columns[0]?.onClick ? () => columns[0].onClick(row) : null}
              >
                {columns.map((col, colIndex) => {
                  const cellValue = getValueByPath(row, col.key);
                  const handleClick = col?.onClick;
                  return (
                    <td
                      key={col.key}
                      className={`w-full break-words p-4 ${
                        colIndex === 0 && displayIndexColumn ? "text-left" : "text-center"
                      } ${colIndex === 0 ? "rounded-l-md" : ""} ${
                        colIndex === columns.length - 1 ? "rounded-r-md" : "p-4"
                      }`}
                      onClick={handleClick}
                    >
                      {renderCell(col, cellValue, rowIndex, colIndex)}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
        <div className="mt-4">
          <Pagination filters={filters} updateFilter={updateFilter} totalCount={count} />
        </div>
      </div>
    </div>
  );
};

export default TableView;
